import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5617277a"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "智能模块", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "协议监测全自动化 安全漏洞闭环管理", -1));
const _hoisted_3 = {
  class: "features-box"
};
const _hoisted_4 = {
  class: "features one"
};
const _hoisted_5 = {
  alt: "工程管理"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "工程管理"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 支持对同一项目中的测试进行统一管理，提升管理效率 ")], -1));
const _hoisted_7 = {
  class: "features two"
};
const _hoisted_8 = {
  alt: "测试管理"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "测试管理"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 提供数十种常见协议测试模版，并支持对协议测试模板进行自定义优化 ")], -1));
const _hoisted_10 = {
  class: "features three"
};
const _hoisted_11 = {
  alt: "协议引擎"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "协议引擎"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 可对发现的异常进行统一管理，支持异常复现，并将提供多维度的分析结果 ")], -1));
const _hoisted_13 = {
  class: "features four"
};
const _hoisted_14 = {
  alt: "缺陷管理"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "text-box"
}, [/*#__PURE__*/_createElementVNode("h3", null, "缺陷管理"), /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, " 支持对不同工程下的测试任务进行管理，实时检测进度及结果 ")], -1));
const _hoisted_16 = {
  class: "product-img"
};
const _hoisted_17 = {
  class: "protocol-box"
};
const _hoisted_18 = {
  class: "box"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createTextVNode("协议支持"), /*#__PURE__*/_createElementVNode("span", null, "50+")], -1));
const _hoisted_20 = {
  class: "protocol-list"
};
const _hoisted_21 = {
  alt: "蓝牙协议"
};
const _hoisted_22 = {
  alt: "wifi协议"
};
const _hoisted_23 = {
  alt: "物联网协议"
};
const _hoisted_24 = {
  alt: "TCP/IP协议"
};
const _hoisted_25 = {
  alt: "网络应用协议"
};
const _hoisted_26 = {
  alt: "加密通信协议"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "omit"
}, "......", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.pageActive ? 'product-Features-box active' : 'product-Features-box')
  }, [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("img", _hoisted_5, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productFeatures1.png')]]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("img", _hoisted_8, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productFeatures2.png')]]), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productFeatures3.png')]]), _hoisted_12]), _createElementVNode("div", _hoisted_13, [_withDirectives(_createElementVNode("img", _hoisted_14, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/productFeatures4.png')]]), _hoisted_15])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon1.png')]]), _createTextVNode("蓝牙协议 ")]), _createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_22, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon2.png')]]), _createTextVNode("WIFI协议 ")]), _createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_23, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon5.png')]]), _createTextVNode("物联网协议 ")]), _createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_24, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon6.png')]]), _createTextVNode("TCP/IP协议 ")]), _createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_25, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon3.png')]]), _createTextVNode("网络应用协议 ")]), _createElementVNode("p", null, [_withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [[_directive_lazy, require('@/assets/img/protocolProduct/protocol_icon4.png')]]), _createTextVNode("加密通信协议 ")]), _hoisted_27])])])])), [[_directive_lazy, require('@/assets/img/protocolProduct/productFeatures-bg.png'), "background-image"]])], 2);
}